import {
  IPB_DIRECTORY_MODERATION_DETAIL,
  IPB_DIRECTORY_MODERATION_DETAIL_ERROR,
  CLEAN_IPB_DIRECTORY_MODERATION_DETAIL,
  CLEAN_IPB_DIRECTORY_MODERATION_DETAIL_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function detailTransactionsNetpayReducer(state = initialState, action) {
  switch (action.type) {
    case IPB_DIRECTORY_MODERATION_DETAIL:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case IPB_DIRECTORY_MODERATION_DETAIL_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_IPB_DIRECTORY_MODERATION_DETAIL:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_IPB_DIRECTORY_MODERATION_DETAIL_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
